import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { LoadingOverlayComponent } from './shared/components/loading-overlay/loading-overlay.component';
import { SessionTimeoutDialogComponent } from './shared/components/session-timeout-dialog/session-timeout-dialog.component';
import { SessionTimeoutService } from './core/services/session-timeout.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingOverlayComponent, SessionTimeoutDialogComponent],
  template: `
    <router-outlet />
    <app-loading-overlay />
    <app-session-timeout-dialog />
  `,
  styles: [`
    :host { display: block; height: 100vh; }
  `],
})
export class AppComponent implements OnInit {
  private themeService = inject(ThemeService);
  // Instantiate so it begins monitoring the session as soon as the app loads.
  private sessionTimeout = inject(SessionTimeoutService);

  ngOnInit(): void {
    this.themeService.init();
  }
}
